// extracted by mini-css-extract-plugin
export default {"section":"gFLNz","header":"JCMFt","headerText":"CE0jL","text":"lqn5J","files":"L2AHH","file":"PV04e"};